import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "PresenceService" */ "./lazyIndex"), { name: "PresenceService" });

export const lazyFetchAssignedPlans: LazyAction<typeof lazyIndex.fetchAssignedPlans, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchAssignedPlans);

export const lazyFetchPresence: LazyAction<typeof lazyIndex.fetchPresence, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchPresence);

export const lazyFetchIdsFromMsGraph: LazyAction<typeof lazyIndex.fetchIdsFromMsGraph, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchIdsFromMsGraph);

export type { GetPresenceBodyType } from "./types/GetPresenceBodyType";
export type { OrganizationAssignedPlan } from "./types/OrganizationAssignedPlan";
export type { PresenceResponseType } from "./types/PresenceResponseType";
